<axs-sheet #sheetRef
           class="terminology-sheet"
           [axsOpenAsModal]="true"
           (axs-on-close)="onClose()">
  <h1 slot="title" class="text-title-2">{{ needHelpContent?.terms }}</h1>
  <div slot="content" class="sheet">
    <div class="sheet__section">
      <div class="sheet__header axs-side-burn text-title-2">{{ calculatorInputsContent?.calculatorInputsHeader }}</div>
      <div class="sheet__description text-body-2" [innerHTML]="calculatorInputsContent?.calculatorInputsDesc"></div>

      <!-- Client Tax Accordion -->
      <axs-accordion-controller [axsFor]="ACCORDION_KEY_ID['clientTax']">
        <div class="sheet__accordion-header">
          <axs-accordion-trigger>
            <button type="button" class="sheet__accordion-button">
              <span class="sheet__accordion-title text-subtitle-1">{{ calculatorInputsContent?.clientTaxInformationHeader }}</span>
            </button>
          </axs-accordion-trigger>
          <axs-indicator class="sheet__accordion-icon" />
        </div>
      </axs-accordion-controller>
      <axs-accordion-panel [id]="ACCORDION_KEY_ID['clientTax']"
                           class="sheet__accordion-panel sheet__accordion-panel--animated"
                           (axs-accordion-is-opening)="onAccordionToggle('clientTax', true)"
                           (axs-accordion-is-closing)="onAccordionToggle('clientTax', false)"
                           [axsIsOpen]="accordionOpenStatus['clientTax']">
        <div class="text-body-2">
          <div class="sheet__subsection">
            <div class="sheet__subsection-title">{{ calculatorInputsContent?.currentTaxInformationHeader }}</div>
            <hr class="sheet__subsection-rule" />

            <div class="sheet__field" id="sheet-field-annual-taxable-income"
              [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-annual-taxable-income'}">
              <div class="sheet__field-title">{{ calculatorInputsContent?.annualTaxableIncomeHeader }}</div>
              @if (stateTaxRatesFromBXR){
              <div class="sheet__field-desc">{{ calculatorInputsContent?.annualTaxableIncomeDesc2 }}</div>
              } @else {
              <div class="sheet__field-desc">{{ calculatorInputsContent?.annualTaxableIncomeDesc }}</div>
              }
            </div>

            <div class="sheet__field" id="sheet-field-tax-filing-status"
                 [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-tax-filing-status'}">
              <div class="sheet__field-title">{{ calculatorInputsContent?.taxFilingHeader }}</div>
              <div class="sheet__field-desc">{{ calculatorInputsContent?.taxFilingDesc }}</div>
            </div>

            @if (stateTaxRatesFromBXR){
            <div class="sheet__field" id="sheet-field-federal-tax-rate"
              [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-federal-tax-rate'}">
              <div class="sheet__field-title">{{ calculatorInputsContent?.federalTaxHeader }}</div>
              <div class="sheet__field-desc margin-bottom-4" [innerHTML]="calculatorInputsContent?.federalTaxDesc"></div>
              <div class="sheet__field-desc" [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-federal-tax-rate-effective'}" id="sheet-field-federal-tax-rate-effective" [innerHTML]="calculatorInputsContent?.federalTaxRateOverride"></div>
            </div>
            
            <div class="sheet__field" id="sheet-field-state-tax-rate"
              [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-state-tax-rate'}">
              <div class="sheet__field-title">{{ calculatorInputsContent?.stateTaxRateHeader }}</div>
              <div class="sheet__field-desc margin-bottom-4" id="sheet-field-state-tax-rate-progressive" [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-state-tax-rate-progressive'}" [innerHTML]="calculatorInputsContent?.stateTaxRate"></div>
              <div class="sheet__field-desc margin-bottom-4" id="sheet-field-state-tax-rate-effective" [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-state-tax-rate-effective'}" [innerHTML]="calculatorInputsContent?.currentStateTaxRateOverride"></div>
              <div class="sheet__field-desc" id="sheet-field-state-tax-rate-no-tax" [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-state-tax-rate-no-tax'}">{{ calculatorInputsContent?.stateTaxRate2 }}</div>
            </div>

            <div class="sheet__field" id="sheet-field-local-tax-rate"
              [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-local-tax-rate'}">
              <div class="sheet__field-title">{{ calculatorInputsContent?.localTaxRateHeader }}</div>
              <div class="sheet__field-desc">{{ calculatorInputsContent?.localTaxRate }}</div>
            </div>
            }
            @else {
            <div class="sheet__field" id="sheet-field-federal-tax-rate"
              [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-federal-tax-rate'}">
              <div class="sheet__field-title">{{ calculatorInputsContent?.federalTaxHeader }}</div>
              <div class="sheet__field-desc" [innerHTML]="calculatorInputsContent?.federalTaxDesc"></div>
            </div>
            
            <div class="sheet__field" id="sheet-field-state-local-tax-rate"
              [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-state-local-tax-rate'}">
              <div class="sheet__field-title">{{ calculatorInputsContent?.statelocalTaxHeader }}</div>
              <div class="sheet__field-desc">{{ calculatorInputsContent?.statelocalTaxDesc }}</div>
            </div>
            }
          </div>

          <div class="sheet__subsection sheet__subsection--future-tax">
            <div class="sheet__subsection-title">{{ calculatorInputsContent?.futureTaxInfoHeader }}</div>
            <hr class="sheet__subsection-rule" />
            <div class="sheet__field" id="sheet-field-future-taxable-income"
                 [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-future-taxable-income'}">
              <div class="sheet__field-title">{{ calculatorInputsContent?.futureTaxableIncomeHeader }}</div>
              <div class="sheet__field-desc">{{ calculatorInputsContent?.futureTaxableIncomeAtDistributionDesc }}</div>
            </div>

            <div class="sheet__field" id="sheet-field-future-tax-filing-status"
                 [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-future-tax-filing-status'}">
              <div class="sheet__field-title">{{ calculatorInputsContent?.taxFilingHeader }}</div>
              <div class="sheet__field-desc">{{ calculatorInputsContent?.futureTaxFilingDesc }}</div>
            </div>

            @if (stateTaxRatesFromBXR){
            <div class="sheet__field" id="sheet-field-future-federal-tax-rate"
              [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-future-federal-tax-rate'}">
              <div class="sheet__field-title">{{ calculatorInputsContent?.federalTaxHeader }}</div>
              <div class="sheet__field-desc margin-bottom-4">{{ calculatorInputsContent?.futureFederalTaxDesc }}</div>
              <div class="sheet__field-desc" [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-future-federal-tax-rate-effective'}" id="sheet-field-future-federal-tax-rate-effective">{{ calculatorInputsContent?.futureFederalTaxRateOverride }}</div>
            </div>
            
            <div class="sheet__field" id="sheet-field-future-state-tax-rate"
              [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-future-state-tax-rate'}">
              <div class="sheet__field-title">{{ calculatorInputsContent?.stateTaxRateHeader }}</div>
              <div class="sheet__field-desc margin-bottom-4" id="sheet-field-future-state-tax-rate-progressive" [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-future-state-tax-rate-progressive'}" [innerHTML]="calculatorInputsContent?.futureStateTaxRate"></div>
              <div class="sheet__field-desc margin-bottom-4" id="sheet-field-future-state-tax-rate-effective" [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-future-state-tax-rate-effective'}" [innerHTML]="calculatorInputsContent?.stateTaxRateOverride"></div>
              <div class="sheet__field-desc" id="sheet-field-future-state-tax-rate-no-tax" [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-future-state-tax-rate-no-tax'}">{{ calculatorInputsContent?.futureStateTaxRate2 }}</div>
            </div>
            
            <div class="sheet__field" id="sheet-field-future-local-tax-rate"
              [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-future-local-tax-rate'}">
              <div class="sheet__field-title">{{ calculatorInputsContent?.localTaxRateHeader }}</div>
              <div class="sheet__field-desc">{{ calculatorInputsContent?.futureLocalTaxRate }}</div>
            </div>
            }
            @else {
            <div class="sheet__field" id="sheet-field-future-federal-tax-rate"
              [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-future-federal-tax-rate'}">
              <div class="sheet__field-title">{{ calculatorInputsContent?.federalTaxHeader }}</div>
              <div class="sheet__field-desc">{{ calculatorInputsContent?.futureFederalTaxDesc }}</div>
            </div>
            
            <div class="sheet__field" id="sheet-field-future-state-local-tax-rate"
              [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-future-state-local-tax-rate'}">
              <div class="sheet__field-title">{{ calculatorInputsContent?.statelocalTaxHeader }}</div>
              <div class="sheet__field-desc">{{ calculatorInputsContent?.futureStatelocalTaxDesc }}</div>
            </div>
            }
          </div>
        </div>
      </axs-accordion-panel>

      <!-- Roth Conversion Accordion -->
      <axs-accordion-controller [axsFor]="ACCORDION_KEY_ID['rothConversion']">
        <div class="sheet__accordion-header">
          <axs-accordion-trigger>
            <button type="button" class="sheet__accordion-button">
              <span class="sheet__accordion-title text-subtitle-1">{{ calculatorInputsContent?.rothConversionDetailsHeader }}</span>
            </button>
          </axs-accordion-trigger>
          <axs-indicator class="sheet__accordion-icon" />
        </div>
      </axs-accordion-controller>
      <axs-accordion-panel [id]="ACCORDION_KEY_ID['rothConversion']"
                           class="sheet__accordion-panel sheet__accordion-panel--animated"
                           (axs-accordion-is-opening)="onAccordionToggle('rothConversion', true)"
                           (axs-accordion-is-closing)="onAccordionToggle('rothConversion', false)"
                           [axsIsOpen]="accordionOpenStatus['rothConversion']">
        <div class="text-body-2">
          <div class="sheet__field" id="sheet-field-years-until"
               [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-years-until'}">
            <div class="sheet__field-title">{{ calculatorInputsContent?.yearsUntilHeader }}</div>
            <div class="sheet__field-desc" [innerHTML]="calculatorInputsContent?.yearsUntilDesc"></div>
          </div>

          <div class="sheet__field" id="sheet-field-payment-method"
               [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-payment-method'}">
            <div id="sheet-field-payment-methods">
              <div class="sheet__field-title">{{ calculatorInputsContent?.paymentMethodHeader }}</div>
              <div class="sheet__field-desc margin-bottom-4" [innerHTML]="calculatorInputsContent?.paymentOptionsDesc"></div>
            </div>

            <div class="sheet__field" id="sheet-field-cash"
                 [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-cash'}">
              <div class="sheet__field-title">{{ calculatorInputsContent?.cashHeader }}</div>
              <div class="sheet__field-desc" [innerHTML]="calculatorInputsContent?.cashDesc"></div>
            </div>

            <div class="sheet__field" id="sheet-field-tax-inefficient"
                 [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-tax-inefficient'}">
              <div class="sheet__field-title">{{ calculatorInputsContent?.taxInefficientHeader }}</div>
              <div class="sheet__field-desc" [innerHTML]="calculatorInputsContent?.taxInefficientDesc"></div>
            </div>

            <div class="sheet__field" id="sheet-field-tax-efficient"
                 [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-tax-efficient'}">
              <div class="sheet__field-title">{{ calculatorInputsContent?.taxEfficientHeader }}</div>
              <div class="sheet__field-desc" [innerHTML]="calculatorInputsContent?.taxEfficientDesc"></div>
            </div>

            <div class="sheet__field" id="sheet-field-ira"
                 [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-ira'}">
              <div class="sheet__field-title">{{ calculatorInputsContent?.iraHeader }}</div>
              <div class="sheet__field-desc" [innerHTML]="calculatorInputsContent?.iraDesc"></div>
            </div>
          </div>

          <div class="sheet__field" id="sheet-field-dividend-tax"
               [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-dividend-tax'}">
            <div class="sheet__field-title">{{ calculatorInputsContent?.dividendTaxHeader }}</div>
            <div class="sheet__field-desc" [innerHTML]="calculatorInputsContent?.dividendTaxDesc"></div>
          </div>

          <div class="sheet__field" id="sheet-field-capital-gains-tax"
               [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-capital-gains-tax'}">
            <div class="sheet__field-title">{{ calculatorInputsContent?.capitalGainsTaxHeader }}</div>
            <div class="sheet__field-desc" [innerHTML]="calculatorInputsContent?.capitalGainsTaxDesc"></div>
          </div>

          <div class="sheet__field" id="sheet-field-annual-return"
               [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-annual-return'}">
            <div class="sheet__field-title">{{ calculatorInputsContent?.annualReturnHeader }}</div>
            <div class="sheet__field-desc" [innerHTML]="calculatorInputsContent?.annualReturnDesc"></div>
          </div>

          <div class="sheet__field" id="sheet-field-dividend-yield"
               [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-dividend-yield'}">
            <div class="sheet__field-title">{{ calculatorInputsContent?.dividendYieldHeader }}</div>
            <div class="sheet__field-desc" [innerHTML]="calculatorInputsContent?.dividendYieldDesc"></div>
          </div>

          <div class="sheet__field" id="sheet-field-cash-yield"
               [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-cash-yield'}">
            <div class="sheet__field-title">{{ calculatorInputsContent?.cashYieldHeader }}</div>
            <div class="sheet__field-desc" [innerHTML]="calculatorInputsContent?.cashYieldDesc"></div>
          </div>

          <div class="sheet__field" id="sheet-field-percent-of-ira"
               [ngClass]="{'sheet__field--highlight': highlightedField === 'sheet-field-percent-of-ira'}">
            <div class="sheet__field-title">{{ calculatorInputsContent?.percentOfIraHeader }}</div>
            <div class="sheet__field-desc" [innerHTML]="calculatorInputsContent?.percentOfIraDesc"></div>
          </div>
        </div>
      </axs-accordion-panel>
    </div>

    <!-- Calculator Results Section -->
    <div class="sheet__section">
      <div class="sheet__results-header axs-side-burn text-title-2">{{ calculatorResultsContent?.calculatorResults }}</div>
      <div class="sheet__results-description text-body-2">
        <div class="sheet__field" id="tax-considerations-content"
             [ngClass]="{'sheet__field--highlight': highlightedField === 'tax-considerations-content'}">
          <div class="sheet__results-content" [innerHTML]="calculatorResultsContent?.calculatorDesc1"></div>
          <div class="sheet__results-content" [innerHTML]="calculatorResultsContent?.calculatorDesc2"></div>
          <div class="sheet__results-content" [innerHTML]="calculatorResultsContent?.calculatorDesc3"></div>
          <div class="sheet__results-content" [innerHTML]="calculatorResultsContent?.calculatorDesc4"></div>
        </div>
        <div class="sheet__results-content" [innerHTML]="calculatorResultsContent?.calculatorDesc5"></div>
        <div class="sheet__results-content" [innerHTML]="calculatorResultsContent?.calculatorDesc6"></div>
      </div>

      <!-- Profitability Point Accordion -->
      <axs-accordion-controller [axsFor]="ACCORDION_KEY_ID['profitabilityPoint']">
        <div class="sheet__accordion-header">
          <axs-accordion-trigger>
            <button type="button" class="sheet__accordion-button">
              <span class="sheet__accordion-title text-subtitle-1">{{ calculatorResultsContent?.profitabilityPoint }}</span>
            </button>
          </axs-accordion-trigger>
          <axs-indicator class="sheet__accordion-icon" />
        </div>
      </axs-accordion-controller>
      <axs-accordion-panel [id]="ACCORDION_KEY_ID['profitabilityPoint']"
                           class="sheet__accordion-panel sheet__accordion-panel--animated"
                           (axs-accordion-is-opening)="onAccordionToggle('profitabilityPoint', true)"
                           (axs-accordion-is-closing)="onAccordionToggle('profitabilityPoint', false)"
                           [axsIsOpen]="accordionOpenStatus['profitabilityPoint']">
        <div class="text-body-2">
          <div class="sheet__field-desc margin-bottom-2" [innerHTML]="calculatorResultsContent?.profitabilityDesc"></div>
        </div>
      </axs-accordion-panel>

      <!-- Break-even Tax Rate Accordion -->
      <axs-accordion-controller [axsFor]="ACCORDION_KEY_ID['breakEvenTaxRate']">
        <div class="sheet__accordion-header">
          <axs-accordion-trigger>
            <button type="button" class="sheet__accordion-button">
              <span class="sheet__accordion-title text-subtitle-1 margin-top-2">{{ calculatorResultsContent?.breakEvenTaxRate }}</span>
            </button>
          </axs-accordion-trigger>
          <axs-indicator class="sheet__accordion-icon" />
        </div>
      </axs-accordion-controller>
      <axs-accordion-panel [id]="ACCORDION_KEY_ID['breakEvenTaxRate']"
                           class="sheet__accordion-panel sheet__accordion-panel--animated"
                           (axs-accordion-is-opening)="onAccordionToggle('breakEvenTaxRate', true)"
                           (axs-accordion-is-closing)="onAccordionToggle('breakEvenTaxRate', false)"
                           [axsIsOpen]="accordionOpenStatus['breakEvenTaxRate']">
        <div class="text-body-2">
          <div class="sheet__field-desc margin-bottom-4" id="break-even-tax-rate-definition"
               [ngClass]="{'sheet__field--highlight': highlightedField === 'break-even-tax-rate-definition'}" [innerHTML]="calculatorResultsContent?.betrDesc">
          </div>
        </div>
      </axs-accordion-panel>
    </div>
  </div>
</axs-sheet>